/* eslint no-console:0 */
// To reference this file, add <%= javascript_pack_tag 'login' %> to the appropriate
// layout file
import ReactRailsUJS from "react_ujs";

const componentRequireContext = require.context("@legacyComponents/login", false);
ReactRailsUJS.useContext(componentRequireContext);
